import { defineStore } from 'pinia';

interface ModalState {
  isOpen: boolean;
  isPlaying: boolean;
  cover: string;
  youtube: string;
}

const modalState = (): ModalState => ({
  isOpen: false,
  isPlaying: false,
  cover: '',
  youtube: '',
});

const useModal = defineStore('modal', {
  state: modalState,
  actions: {
    openModal(boolean: boolean) {
      this.isOpen = boolean;
    },
    playVideo(boolean: boolean) {
      this.isPlaying = boolean;
    },
    setCover(url: string) {
      this.cover = url;
    },
    setYoutube(url: string) {
      this.youtube = url;
    },
  },
});

export default useModal;
